
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Layer 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20 5H4a1 1 0 010-2h16a1 1 0 010 2zm-3 8H7a1 1 0 010-2h10a1 1 0 010 2zm-2.75 8h-4.5c-.41 0-.75-.45-.75-1s.34-1 .75-1h4.5c.41 0 .75.45.75 1s-.34 1-.75 1z"}})])
          )
        }
      }
    